import { createFileRoute } from "@tanstack/react-router";
import { z } from "zod";
import { LedgerPage } from "@/features/ledger/LedgerPage";

const search = z.object({
  status: z.enum(["all", "unbilled", "reserved", "invoiced", "written-off"]).optional(),
  by: z.enum(["project", "client", "person"]).optional(),
});

export const Route = createFileRoute("/_app/time/ledger")({
  validateSearch: search,
  component: () => <LedgerPage search={Route.useSearch()} />,
});
